import type { Filter } from '@/types/Filters'

export interface AdaptedFilter {
  keyValue: string
  filterId: string
  selectedVal: string[]
}

export function adaptFilter(filter: Filter): AdaptedFilter | null {
  if (!filter.filterValue) {
    return null
  }
  return {
    keyValue: filter.keyValue,
    filterId: filter.filterId,
    selectedVal: Array.isArray(filter.filterValue) ? filter.filterValue.filter((val) => val) : [filter.filterValue].filter((val) => val)
  }
}
